<template>
    <div class="server-agreement">
        
        <div class="title">
            蓝湖服务条款
            <div class="back-icon" @click="goBack"><img src="@/assets/imgs/title_back.png" /></div>
        </div>
        <div class="update-date">更新日期: 2020年02月25日</div>
        <div class="effective-date">生效日期: 2020年02月25日</div>

        <p>蓝湖是由北京尽微至广信息技术有限公司及/或其关联方（以下简称“尽微至广”或“我们”）提供的互联网软件服务（以下简称“蓝湖”）。本服务条款（以下简称“本条款”）是您（以下简称“您”或“用户”）与尽微至广之间关于您访问和使用蓝湖以及尽微至广提供的其他服务（以下简称“蓝湖服务”或“本服务”）的协议。</p>

        <p>在本服务创建账户并使用之前，您必须首先同意本条款。<span class="text">在接受本条款之前</span>，请您仔细阅读全部内容，如您无法准确理解或不同意本条款的任一内容，请不要访问、使用蓝湖或尽微至广提供的其他任何服务。<span class="text">您通过网络页面点击确认、实际购买或使用本服务等操作均表示您已阅读并充分理解本协议之内容，与尽微至广就使用或订购相应产品和/或服务已达成合意，并同意接受本条款的全部约定内容，受其约束。</span></p>

        <p><span class="text">特别提示您关注</span>本条款关于<span class="text">限制、免除尽微至广责任的条款、对用户的权利限制条款、违规/违约行为的认定处理、以及管辖法院的选择</span>等条款内容，前述条款可能以<span class="bold">加粗</span>及/或<span class="underline">加下划线</span>形式提示您注意。</p>

        <p>您同意尽微至广有权不时地对本条款进行修订，且毋须另行通知。修订后的条款一旦在网页上公布即有效代替原来的服务条款。您继续访问和使用蓝湖即视为您接受修订后的服务条款。否则，您有权通过停止访问蓝湖且拒绝使用服务、删除您在蓝湖上的信息和账户等方式来终止服务条款。</p>

        <p>如果您代表某个机构而非您个人注册、登录和使用蓝湖，则您将被认为获得充分授权代表该机构同意本服务条款以及服务条款不时的修改和补充。</p>

        <ul>
            <div class="title">服务内容</div>
            <li>本条款中的“蓝湖服务”指：尽微至广向您提供lanhuapp.com网站（即蓝湖官网）上所展示的产品和服务，包括但不限于通过网页、移动端APP等方式提供的全部服务，具体服务内容以您所使用或订购的内容为准。</li>
            <li>根据实际需要和尽微至广不时提供的其他服务内容，尽微至广可能与您另行签订其他协议。同时，即使未另行签订其他协议，您使用蓝湖的具体服务也将被视为您同意尽微至广关于该等具体服务的任何要求。<span class="text">如果其他协议和本条款之间存在冲突，应以其他协议为准，但以该冲突和与该协议特定事宜相关为限。</span></li>
            <li>尽微至广保留随时变更、中止或终止部分免费服务的权利，并保留根据实际情况随时调整蓝湖提供的免费服务种类、形式的权利。<span class="text">尽微至广不承担因蓝湖提供的任何免费服务的调整给您造成的损失。</span>尽微至广有权在未来恰当的时机对任何免费服务内容收取相应的服务费用。尽微至广做出上述调整前会以站内通知、邮件或官网公告等方式通知您，并给予您合理期限以完成数据的下载和备份。蓝湖免费版服务可能在人数、项目数量或功能上有所限制，您可以通过开通付费版解除该等限制，具体信息以蓝湖官网描述为准。</li>
            <li>您在使用蓝湖服务前，应充分阅读并理解蓝湖官网对相应服务的描述，尤其是对免费服务、各级收费服务在功能、服务标准上的限制。<span class="text">对由于您未能充分理解上述描述和限制而造成的任何损失，尽微至广不承担任何法律责任。</span></li>

            <div class="title">账户</div>
            <li>为访问与使用蓝湖，您必须注册一个蓝湖账户。注册账户时，您需要提供真实、准确的信息。如果您的信息发生变更，请及时在您的账户中对信息进行更新。您对（a）您的账户的保密性，以及用于启用您访问服务的任何密码、身份验证密钥或安全凭据的安全性负责，和（b）所有在您账户下的活动，不论是您还是您的最终用户的活动负责。如果您的账户下有任何未经授权或滥用行为或者任何与服务相关的安全事件，您将立即通知我们。<span class="text">您认可并同意我们不会对您账户中任何未经授权或滥用行为负责</span>，除非这是由我们违反本条款所造成的。</li>
            <li>尽微至广和您应遵守相关法律法规进行实名认证。就蓝湖服务的使用，尽微至广可能要求您提供进一步的身份资料、经营资质和信息，以完成身份认证或资格验证。仅在完成相应身份认证及资格验证后，您才可以订购及使用相关服务。您理解并同意尽微至广有权自行或委托第三方，审查您在实名认证时提供的信息是否真实、准确及有效。您知晓并同意，如您未依照相关法律法规及尽微至广的要求完成实名认证，将影响您访问或使用本服务。</li>
            <li>您声明并保证，您向尽微至广提供的信息均为真实、准确、有效、最新的，否则您应承担由此产生的一切法律责任。尽管有前述规定，尽微至广无义务对任何用户的任何登记资料承担任何责任，包括但不限于鉴别、核实任何登记资料的真实性、准确性、完整性、适用性及/或是否为最新资料的责任。</li>
            <li>尽微至广建议您妥善保管您的注册邮箱、手机号、密码和名称，准确输入该等信息将作为您访问登录蓝湖并享有服务的关键环节。如果您发现有人未经授权使用您的账户信息或怀疑任何人未经授权可能能够访问您的私有内容，您应立即更改密码，并向我们反馈。</li>

            <div class="title">使用</div>
            <li><span class="text">您声明并保证您上传或储存在蓝湖中的内容不违反本条款并且符合法律法规。</span>您应对您的内容的合法性、准确性、完整性和可靠性负责。您应负责获得并持续保有任何与您的内容相关的通知、同意或授权。除非法律另有明确规定，否则尽微至广不承担任何与您的内容有关的义务和责任。<span class="text">若您在蓝湖上传、储存侵犯他人知识产权或其他违法、违规的内容，尽微至广有权利予以删除并保留移交司法机关处理的权利。</span></li>
            <li>您不得使用蓝湖上传、储存、共享、发送或传播任何敏感信息和违反国家法律法规的信息，包括但不限于下列信息：</li>
            <div>- 反对宪法所确定的基本原则的；</div>
            <div>- 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</div>
            <div>- 损害国家荣誉和利益的；</div>
            <div>- 煽动民族仇恨、民族歧视，破坏民族团结的；</div>
            <div>- 破坏国家宗教政策，宣扬邪教和封建迷信的；</div>
            <div>- 散布谣言，扰乱社会秩序，破坏社会稳定的；</div>
            <div>- 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</div>
            <div>- 侮辱或者诽谤他人，侵害他人合法权益的；</div>
            <div>- 含有法律、行政法规禁止的其他内容的。</div>

            <div>您承诺发表言论要：爱国、守法、自律、真实、文明。不传播任何非法的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、危害国家安全的、泄露国家机密的、破坏国家宗教政策和民族团结的以及其它违反法律法规及政策的内容。若您的行为不符合以上提到的服务条款蓝湖将作出独立判断立即暂停或终止用户的服务账号。用户需自行对其全部行为承担法律责任，蓝湖不承担任何法律责任。</div>

            <li><span class="text">您应当对您使用蓝湖的一切行为及所有在您账户下的活动，不论是您还是您授权的他人的活动负责。</span>您不得利用蓝湖从事违反法律法规、违反本用户协议约定、危害网络安全、危害计算机系统安全、破坏蓝湖产品完整性或其他侵害蓝湖及任何第三人利益的活动。<span class="text">若您从事了上述行为，尽微至广有权暂停或终止您的账户，并拒绝您于现在和未来使用蓝湖之全部或任何部分，由此对尽微至广或第三人造成的损失或由此产生的一切法律责任均由您全部承担。</span></li>

            <div class="title">内容和知识产权</div>
            <li>尽微至广对您在本服务提交的内容没有所有权，这些内容的所有权仍然归您所有。您明白尽微至广对您提供的任何内容不在任何方面负责或负有责任，尽微至广没有义务预先审查此类内容。但是，蓝湖有权随时决定内容是否合适和与本条款相符；如果发现此类内容违反本条款或在其他方面令人反感，尽微至广可随时并有绝对酌情权预先审查、转移、拒绝、修改和/或删除内容，而不需事先通知。用户使用本服务的行为若有任何违反国家法律法规或侵犯任何第三方合法权益的情形，尽微至广有权直接删除该等违反规定的信息，并可以暂停或终止向该用户提供服务。</li>
            <li>本服务的所有权及所有相关的知识产权（包括但不限于源代码、目标代码、文档资料、界面设计、版面框架、以及任何由尽微至广根据维护与技术支持提供的软件、资料等）归尽微至广所有。您认同尽微至广拥有的所有权及知识产权，并承诺尊重及不以任何方式侵害尽微至广的所有权及知识产权。未经尽微至广书面许可，您不能复制、拷贝转让、许可或提供他人使用上述知识成果，或者重用任何部分代码和外观设计，否则您应承担相应的法律责任，<span class="text">且尽微至广有权终止您对蓝湖的使用且不退还任何费用。</span></li>

            <div class="title">隐私政策</div>
            <li>使用本服务，即表示您同意尽微至广合法收集和使用有关您及您所使用本服务的技术性或诊断性信息。手机端可能会用到录音、拍照、读取相册等权限，仅在用于用户反馈建议和问题时调用。收集到的这些信息将用于改进蓝湖服务的内容和技术，提升我们的服务品质。尽微至广不会将您的信息和内容分享或出售给其他的组织。但以下情况除外：</li>
            <div>- 事先获得您的明确授权；</div>
            <div>- 遵守适用的法律法规；</div>
            <div>- 遵守法院命令或其他法律程序的规定；</div>
            <div>- 遵守相关政府主管部门的要求；</div>
            <div>- 与国家安全、国防安全、公共安全、公共卫生、公共利益直接相关的；</div>
            <div>- 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</div>
            <div>- 尽微至广认为为遵守适用的法律法规、维护社会公共利益、或保护尽微至广的客户、其他用户或雇员的人身和财产安全或合法权益所合理必需的；</div>
            <div>- 您违反了本服务条款，且尽微至广出于维权需要向第三方提供的；</div>
            <div>- 法律法规规定的其他情形。</div>

            <li>保护用户个人信息是尽微至广的一项基本原则，<span class="text">尽微至广将按照《蓝湖隐私政策》约定收集、使用、储存和分享您的个人信息。您声明并保证，已仔细阅读、完全理解并同意上述《蓝湖隐私政策》的全部内容。您对本条款的接受将视为您对《蓝湖隐私政策》的接受、充分理解和同意，若您不同意本条款及《蓝湖隐私政策》，请您立即停止使用我们提供的任何服务或产品，若您继续使用，则视为您已同意本条款及《蓝湖隐私政策》。</span></li>

            <div class='title'>数据和信息安全</div>
            <li><span class="text">尽微至广将依照法律、行政法规的规定和国家标准的强制性要求，采取合理的技术措施和其他必要措施，努力保护您的信息安全。但是，互联网数据传输、存储、转换均可能存在一定未知且不确定的数据安全风险，该等风险将导致包括但不限于数据丢失、泄露、损坏、无法读取或提取等后果。您确认，您已明确知晓并同意接受该等因互联网引发的风险和后果，并已采取恰当的措施（例如数据备份等），以便在该等风险发生时将损失降至最低。</span></li>
            <li><span class="text">因互联网技术本身等非尽微至广原因导致危害您数据安全，导致您的数据丢失或损坏或商业利益损失的，尽微至广不承担任何赔偿责任。因尽微至广重大过失造成危害您数据安全的，尽微至广对您承担的赔偿责任以向您收取的服务费用为上限。</span></li>
            <li>您可自行对您上传、储存在蓝湖中的数据进行删除、更改等操作。就数据的删除、更改等操作，您应谨慎操作。当服务提前终止（包括账户注销或其他原因导致的提前终止等）时，除法律法规明确规定、主管部门要求或双方另有约定外，蓝湖仅在一定的缓冲期（以您所订购的服务适用的专有条款、产品文档、服务说明等所载明的时限为准）内继续存储您的数据（如有），缓冲期届满尽微至广将删除所有用户业务数据，包括所有缓存或者备份的副本，不再保留您的任何数据。</li>
            <div><span class="text">用户业务数据一经删除，即不可恢复；您应承担数据因此被删除所引发的后果和责任，您理解并同意，尽微至广没有继续保留、导出或者返还用户业务数据的义务。</span></div>

            <div class="title">免责声明</div>
            <div>您知悉并同意，下列情况下，尽微至广无需向您承担任何责任：</div>
            <li><span class="text">由于您维护不当或保密不当，导致数据、资料、口令、密码等丢失或泄漏，或其他非因尽微至广原因导致的个人信息的泄漏，尽微至广不承担任何法律责任；</span></li>
            <li><span class="text">任何由于不可抗力、黑客攻击、电脑病毒侵入、网络运营商原因或政府管制等尽微至广无法合理控制的原因而造成蓝湖使用中止、中断、延误、使用限制、使用异常、使用不能、暂时性网站关闭等，尽微至广不承担任何法律责任；</span></li>
            <li><span class="text">您应对通过蓝湖上传或储存文件、输入数据的合法性以及获得文件、数据、内容的方式的合法性负责，因上述文件、数据、内容引发的一切纠纷，由您承担全部法律责任，尽微至广不承担任何法律责任；</span></li>
            <li><span class="text">互联网是一个开放平台，如果您将图片、文字等内容上传并传播，有可能会被其他组织或个人复制、转载、擅改或做其它非法用途，您应充分意识到此类风险的存在。您同意使用尽微至广服务所存在的此类风险及后果将完全由您自己承担，尽微至广不承担任何责任。</span></li>
            <li><span class="text">您理解并确认，受技术所限，尽微至广无法保证其所提供的服务毫无瑕疵，但我们承诺将不断提升服务质量及服务水平，为您提供更加优质的服务。据此，您同意：如果尽微至广所提供的服务虽然存在瑕疵，但该等瑕疵是当时行业技术水平所无法避免的，其将不被视为违约，尽微至广无须因此向您承担任何责任。</span></li>
            <li><span class="text">服务变更/中断/终止</span></li>
            <li>您可随时注销您的账户并停止使用蓝湖服务。注销账户的方式可遵照蓝湖官网的指引。您声明并保证，在您自主注销账户前已经将您上传、储存在蓝湖中的数据下载、备份完毕。<span class="text">您自主注销账户后，蓝湖将不再保留您的数据。</span></li>
            <li>您理解并同意，如因系统维护或升级的需要而暂停蓝湖服务、调整服务功能的，尽微至广将尽可能事先在网站上进行通告，<span class="text">但不因此承担任何法律责任。</span></li>
            <li>尽微至广可随时在如下情况下，不需事先通知，立即终止或暂停您所有或部分账户和/或本服务之进入：</li>
            <div>- 您提供的资料不真实，或违反其他用户个人资料提供规则；</div>
            <div>- 您违反法律法规、本条款或您与尽微至广的其他约定；</div>
            <div>- 您要求取消或终止您的账户；</div>
            <div>- 未经尽微至广同意，将蓝湖产品本身用于商业目的；</div>
            <div>- 需要听从法庭传票、法律命令或遵循法律程序；</div>
            <div>- 根据相关法律法规或政府机构的要求；</div>
            <div>- 因自然灾害、战争等不可抗力；</div>
            <div>- 本条款发生变更或修改，您不同意变更或修改后的用户条款。</div>

            <li>您理解并认可，为技术升级、服务体系升级、或因经营策略调整或配合国家重大技术、法规政策等变化，<span class="text">尽微至广不保证永久的提供某种服务，或可能变更所提供服务的形式、规格或其他方面</span>，在终止该种服务或进行此种变更前，尽微至广将尽最大努力且提前以网站公告、站内信、邮件或短信等一种或多种方式进行事先通知；如终止提供该种服务的，尽微至广将尽合理的努力给您预留合理的时间，妥善处理后续事宜。</li>
            <li>⼀旦您的账户被终止，您将无法正常使用本服务。此外，您可以选择删除您的账户下的所有信息和内容。</li>
            
            <div class="title">本服务条款的完善和修改</div>
            <li>尽微至广有权根据互联网的发展和中华人民共和国有关法律、法规的变化，不时地完善和修改本条款。尽微至广保留随时修改本条款的权利，并会将修改后的服务条款在蓝湖官网上公布，该等公布视为对您的有效通知送达。<span class="text">您在使用尽微至广的服务时，有必要对最新的《蓝湖服务条款》进行仔细阅读和重新确认，当发生相关争议时，以最新的服务条款为准。</span></li>
            <li>如果您不同意尽微至广对本条款所做的修改，您应立即停止使用蓝湖服务。<span class="text">如果用户继续使用蓝湖服务，则视为用户接受我方对本条款所做的修改。</span></li>

            <div class="title">青少年特别条款</div>
            <li>蓝湖服务主要面向成年人。若您是未成年人，请您确保您的监护人已仔细阅读、理解并接受本条款。并在征得您的监护人同意的前提下使用蓝湖服务或向尽微至广提供信息。</li>
            <li>您因使用蓝湖服务所产生及与本条款有关的一切争议，由尽微至广与您协商解决。协商不成时，任何一方均可向尽微至广住所地人民法院提起诉讼。</li>
            <li>若用户利用本服务从事任何违法或侵权行为，由用户自行承担全部责任，尽微至广不承担任何法律责任。因此给尽微至广或任何第三方造成任何损失的，用户应负责全额赔偿。</li>

            <div class="title">与我们联系</div>
            <div>当您有其他的投诉、建议、反馈相关问题时，请通过官方QQ群：1002536314与我们联系。您也可以将您的问题发送至zhufeng@zhibenyuan.cc，或寄到如下地址：</div>
            <div>北京市朝阳区望京SOHO塔三B座3801北京尽微至广信息技术有限公司隐私保护中心（收），邮编：100123</div>

            <div class="title">其他条款</div>
            <li><span class="text">尽微至广有权不经过您的事先单独同意，将本条款的权利义务全部或者部分转移给尽微至广的关联公司，但尽微至广保证不会实质性降低您可获得服务的质量。</span></li>
            <li>未经尽微至广事先同意，您不得将本条款项下的任何权利义务转让给第三人。</li>
            <li>本条款部分条款因任何原因被宣告无效或不可履行的，不影响其他条款的效力，其他条款仍应继续适用。任何无效或不可履行的条款将被替换为与本协议目的和意图一致的另一条款。</li>
            <li>因超出尽微至广合理控制的情况致使尽微至广未能遵守所有条款和条件，则尽微至广对这类不履约概不承担任何责任。</li>
            <li>尽微至广可通过站内消息或您在注册账户、使用蓝湖服务过程中提供的电话、电子邮件或其他联系方式向您发出通知。上述通知一经发出即视为对您产生效力，<span class="text">您有义务保证您的联系方式的有效性。</span></li>
            <li>除非尽微至广以书面方式确认并同意，尽微至广未履行本条款中任何权利或条款的行为不构成尽微至广对相关权利或条款的放弃。</li>
            <li>最近修订于2020年02月25日。尽微至广保留一切权利。</li>

            <div class="footer">北京尽微至广信息技术有限公司</div>




        </ul>
    </div>
</template>
<style lang="scss" scoped>
.server-agreement {
    height: 100%;
    background: #fff;
    padding-top: 40px;
    padding-bottom: 20px;
    padding-left: 14px;
    padding-right: 14px;
    overflow: auto;
    .back-icon {
        z-index: 10;
        opacity: 0.7;
        position: absolute;
        top: -0.5rem;
        padding: 0.5rem;
        left: -0.5rem;
        border: 0.1rem solid transparent;
        box-sizing: border-box;
        background-origin: content-box;
        img {
            width: 0.9rem;
        }
    }

    .title {
        text-align: center;
        font-size: 18px;
        font-weight: 700;
        position: relative;
    }
    .update-date {
        font-size: 14px;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .effective-date {
        margin-bottom: 10px;
        font-size: 14px;
    }
    p {
        font-size: 14px;
        text-align: left;
        margin-bottom: 18px;
        .text {
            font-weight: 700;
            text-decoration: underline;
        }
        .bold {
            font-weight: 700;
        }
        .underline {
            text-decoration: underline;
        }
    }
    ul {
        font-size: 14px;
        list-style-type: disc;
        list-style-position: inside;
        text-align: left;
        li {
            list-style-type: disc;
            margin-bottom: 8px;
            margin-top: 4px;
        }
        .title {
            text-align: left;
            font-size: 15px;
            font-weight: 700;
            margin-bottom: 8px;
        }
        .footer {
            text-align: right;
            font-weight: bold;
        }
    }
}
</style>
<script>
// import avatar from "@/components/common/Avatar"
// import lanhuDialog from "../../components/common/lanhu-dialog"
// import actionsheet from "../../components/common/Actionsheet"
// import settingsData from '../../settings.js'
// import API from "@/api/api.js"

export default {
    name: "serverAgreement",
    components: {},
    data() {
        return {}
    },
    computed: {},
    mounted() {},
    methods: {
        goBack(){
            this.$router.go(-1)
        }
    }
}
</script>
